export const timestampEncryConfig = {
    field: "zlpt",
};
